import React from 'react';
import classNames from 'classnames';
import Enumerable from 'linq';
import styles from './styles/Top.sass';

class Top extends React.Component {
  componentDidMount() {
    const { getTop } = this.props;

    getTop();
  }

  render() {
    const {
      header,
      news,
      banner,
    } = this.props;

    return (
      <div className={styles.top}>
        <header className={styles.header}>
          {
            ('imageName' in header) && (
              <a
                href={header.url}
                target="_blank"
              >
                <img
                  src={`/images/${header.imageName}`}
                  alt="header"
                />
              </a>
            )
          }
        </header>
        <div className={styles.contents}>
          <div className={styles.left}>
            <div className={styles.inner}>
              <ul>
                {
                  Enumerable
                    .from(news)
                    .select((element, index) => {
                      let jungle = '';

                      switch (element.jungle) {
                        case 'CD': {
                          jungle = styles.cd;
                          break;
                        }
                        case 'COMIC': {
                          jungle = styles.comic;
                          break;
                        }
                        case 'GOODS': {
                          jungle = styles.goods;
                          break;
                        }
                        case 'OTHER': {
                          jungle = styles.other;
                          break;
                        }
                        default: {
                          break;
                        }
                      }

                      return (
                        <li key={index}>
                          <div className={styles.date}>
                            {element.date}
                          </div>
                          <div className={styles.heading}>
                            <div className={classNames(styles.jungle, jungle)}>
                              {element.jungle}
                            </div>
                            <div className={styles.title}>
                              {element.title}
                            </div>
                          </div>
                          {
                            element.text ? (
                              <div className={styles.text}>
                                {element.text}
                              </div>
                            ) : null
                          }
                          {
                            element.imageName ? (
                              <div className={styles.image}>
                                {
                                  element.url ? (
                                    <a
                                      href={element.url}
                                      target="_blank"
                                    >
                                      <img
                                        src={`/images/${element.imageName}`}
                                        alt={index}
                                      />
                                    </a>
                                  ) : (
                                      <img
                                        src={`/images/${element.imageName}`}
                                        alt={index}
                                      />
                                    )
                                }
                              </div>
                            ) : null
                          }
                        </li>
                      );
                    })
                    .toArray()
                }
              </ul >
            </div >
          </div >
          <div className={styles.right}>
            <ul className={styles.banner}>
              {
                Enumerable
                  .from(banner)
                  .select((element, index) => (
                    <li key={index}>
                      <a
                        href={element.url}
                        target="_blank"
                      >
                        <img
                          src={`/images/${element.imageName}`}
                          alt={index}
                        />
                      </a>
                    </li>
                  ))
                  .toArray()
              }
            </ul>
          </div>
        </div >
      </div >
    );
  }
}

export default Top



// WEBPACK FOOTER //
// src/components/top/index.js